import HttpService from "./htttp.service";

class SuppliersService {
  // SuppliersEndpoint = process.env.API_URL;

  getSuppliers = async () => {
    const getSuppliers = "dash/suppliers";
    return await HttpService.get(getSuppliers);
  };

  getSingleSupplier = async (id) => {
    const getSingleSupplier = `dash/suppliers/${id}`;
    return await HttpService.get(getSingleSupplier);
  };

  createNewSupplier = async (payload) => {
    const createNewSupplier = "dash/suppliers/new";
    return await HttpService.post(createNewSupplier, payload);
  };

  updateSupplier = async (id, payload) => {
    const updateSupplier = `dash/suppliers/${id}`;
    return await HttpService.put(updateSupplier, payload);
  };

  deleteSupplier = async (id) => {
    const deleteSupplier = `dash/suppliers/${id}`;
    return await HttpService.delete(deleteSupplier);
  };
}

export default new SuppliersService();
